<template>
  <div class="pa-3">
    <div class="tasks-toolbar mb-4">
      <Select
        label="Project"
        :items="projectItems"
        :value="this.$route.params.projectId"
        @input="this.$router.push({ name: 'tasks', params: { projectId: $event } })"
        style="min-width:160px;"
      ></Select>
      <div class="tasks-toolbar__actions">
        <button class="tasks-toolbar__btn" @click="$refs.createBoard.showDialog()" title="Add board" :disabled="!selectedProject">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M8 3v10M3 8h10"/></svg>
          New board
        </button>
        <button class="tasks-toolbar__btn" @click="showArchivedTasks = !showArchivedTasks" :class="{ 'tasks-toolbar__btn--active': showArchivedTasks }" title="Archived tasks">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 5.5v9H2v-9M1 2h14v3.5H1zM6.5 8h3"/></svg>
          Archive
        </button>
      </div>
    </div>
    <Tasks
      v-if="!showArchivedTasks && selectedProject"
      :project="selectedProject"
    ></Tasks>
    <div v-else-if="showArchivedTasks && selectedProject" class="archive-panel">
      <ArchivedTasks :projectId="selectedProject.id"></ArchivedTasks>
    </div>
    <CreateBoardDialog
      :projectId="selectedProject?.id"
      ref="createBoard"
    ></CreateBoardDialog>
  </div>
</template>

<script>
  import Tasks from '../modules/Tasks'
  import Button from '../common/Button'
  import ArchivedTasks from '../modules/ArchivedTasks'
  import CreateBoardDialog from '../modules/CreateBoardDialog'
  import Select from '../common/Select'

  export default {
    name: 'TasksView',
    components: {
      Tasks,
      ArchivedTasks,
      Button,
      Select,
      CreateBoardDialog
    },
    props: [],
    data: () => ({
      showArchivedTasks: false
    }),
    mounted() {
      if (!this.$route.params.projectId && this.projectsOrdered.length) {
        this.$router.push({
          name: this.$route.name,
          params: { projectId: this.projectsOrdered[0].id }
        })
      }
    },
    watch: {},
    computed: {
      projectItems() {
        return this.$store.getters.projectItems
      },
      selectedProject() {
        return this.projectsOrdered.find(
          (project) => String(project.id) === String(this.$route.params.projectId)
        )
      },
      projectsOrdered() {
        return this.$store.getters.projectsOrdered
      }
    },
    methods: {}
  }
</script>

<style scoped>
.tasks-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.tasks-toolbar__actions {
  display: flex;
  gap: 6px;
  margin-left: auto;
}

.tasks-toolbar__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  height: 34px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: white;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.55);
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s, background 0.12s;
}

.tasks-toolbar__btn svg {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
}

.tasks-toolbar__btn:hover {
  color: rgba(0, 0, 0, 0.8);
  border-color: rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.02);
}

.tasks-toolbar__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

.tasks-toolbar__btn--active {
  color: var(--primary);
  border-color: rgba(61, 106, 144, 0.3);
  background: var(--primary-muted);
}

.archive-panel {
  padding: 0 12px;
}
</style>
